module.exports = __webpack_public_path__ + "static/media/usb-a-gold.dd809756.svg";